
class Security
{

	/**
	 * Constructor
	 */
	Security()
	{
		// determine user fingerprint
		if (window.requestIdleCallback)
		{
		    requestIdleCallback(function ()
		    {
		        Fingerprint2.get(function (components)
		        {
		        	var fingerprint = Fingerprint2.x64hash128(components.map(function (pair) { return pair.value }).join(), 31)
		        	save(fingerprint);
		        })
		    })
		}
		else
		{
		    setTimeout(function ()
		    {
		        Fingerprint2.get(function (components)
		        {
		        	var fingerprint = Fingerprint2.x64hash128(components.map(function (pair) { return pair.value }).join(), 31)
		        	save(fingerprint);
		        })
		    }, 500)
		}
	}

	/**
	 * Save fingerprint to db
	 */
	save(fingerprint)
	{
		$.ajax(
		{
			url: "/services/save-fingerprint.php",
			type: "POST",
			data: {
				"fingerprint":fingerprint
			},
			success: function(data)
			{
				// ignore
			}
		});
	}

	static checkCSRFMethod(method)
	{
		return (/^(GET|HEAD|OPTIONS)$/.test(method));
	}

	static loadCSRF(token)
	{
		var obj = this;

		if (token == "")
		{
			token = $('meta[name="csrf-token"]').attr('content');
		}

		$.ajaxSetup(
		{
			beforeSend: function(xhr, settings)
			{
				if (!obj.checkCSRFMethod(settings.type) && !this.crossDomain)
				{
					xhr.setRequestHeader('anti-csrf-token', token);
				}
			}
		});
	}

	static AJAX(url, data, type, success, error, token)
	{
		this.loadCSRF(token);

		$.ajax(
		{
			url: url,
			data: data,
			type: type,
			success: success,
			error: error
		});
	}

}
